const ITEMS = ["PUBLICITÉ", "CINÉMA", "SÉRIES", "ARTISTES", "SYNCHRO", "HABILLAGE SONORE", "BANDE-ORIGINALE", "PODCAST"];

export const Marquee = ({ dark = false }) => {
  const row = (
    <>
      {ITEMS.map((it) => (
        <span key={it} className="mx-5 flex items-center gap-5">
          <span className="font-display text-lg font-medium italic sm:text-xl">{it}</span>
          <span className="h-1 w-1 rounded-full bg-amber-500/70" />
        </span>
      ))}
    </>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-white/[0.08] py-4 ${dark ? "bg-black text-zinc-700" : "bg-surface text-zinc-600"}`}
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
